import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';

@Component({
  selector: 'app-progressbar',
  templateUrl: './progressbar.component.html',
  styleUrls: ['./progressbar.component.css']
})

export class ProgressbarComponent implements OnInit {
  @Input() datavalue:number=0;
  constructor() { }

  ngOnInit() {
  }

}
